import { useApi } from '@backstage/frontend-plugin-api';
import { ReactNode } from 'react';
import useAsync from 'react-use/esm/useAsync';
import { azureCostsApiRef } from '../api';

/**
 * Renders the "Azure costs" sidebar item only for people who may see some
 * costs (plan 005): nothing while it asks, nothing on any error.
 */
export const CostsNavGate = ({ children }: { children: ReactNode }) => {
  const api = useApi(azureCostsApiRef);
  const { value } = useAsync(() => api.accessMe(), [api]);
  return value && (value.admin || value.systems.length > 0) ? (
    <>{children}</>
  ) : null;
};
